import React, { useEffect, useState } from 'react';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { useQuote } from './QuoteDialog';
export function MobileStickyCTA() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    openQuote
  } = useQuote();
  // Only show the sticky bar once the hero section (which already has its own
  // "Get Your Free Estimate" button) has scrolled out of view.
  const [showBar, setShowBar] = useState(false);
  useEffect(() => {
    if (!isMobile) {
      setShowBar(false);
      return;
    }
    const hero = document.getElementById('hero');
    if (!hero) {
      // No hero found — fall back to always showing the bar on mobile.
      setShowBar(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      // Hero visible -> hide bar; hero scrolled past -> show bar.
      setShowBar(!entry.isIntersecting);
    }, {
      // Trigger as soon as essentially none of the hero remains on screen.
      threshold: 0
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, [isMobile]);
  if (!isMobile) return null;
  return <AnimatePresence data-id="element-112">
      {showBar && <Box component={motion.div} initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      type: 'tween',
      duration: 0.28,
      ease: 'easeOut'
    }} sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: t => t.zIndex.appBar + 1,
      bgcolor: 'white',
      borderTop: '1px solid',
      borderColor: 'divider',
      p: 1.5,
      // Respect iOS safe-area inset at the bottom of the screen
      pb: 'calc(12px + env(safe-area-inset-bottom))',
      boxShadow: '0 -4px 12px rgba(0,0,0,0.08)'
    }} data-id="element-113">
          <Button variant="contained" color="secondary" fullWidth onClick={openQuote} sx={{
        py: 1.5,
        fontSize: '1.05rem',
        fontWeight: 700
      }} data-id="element-114">
            Get a Free Quote
          </Button>
        </Box>}
    </AnimatePresence>;
}